<template>

    <div class="main-slider swiper-container js-main-slider">
        <div class="main-slider__inner swiper-wrapper">
            <div class="main-slider__slide swiper-slide">
                <div class="main-banner">
                    <div class="main-banner__bg">
                        <div class="main-banner__img img" style="background-image: url(/images/main-slider/desctop/new-main-6.jpg);"></div>
                    </div>
                    <div class="main-banner__head card">
                        <div class="main-banner__head-inner">
                            <div class="main-banner__title h1">С любого устройства</div>
                            <div class="main-banner__caption h4">Заходите в свой личный кабинет с компьютера, планшета или смартфона на базе Android.</div>
                        </div>
                        <div class="main-banner__bottom">
                            <div class="app-links">
                                <div class="app-links__title h3">Скачать приложение:</div>
                                <!--<a target="_blank" href="https://apps.apple.com/ru/app/%D1%81%D0%B3%D0%BA/id1451473917" class="app-links__button button-icon button-icon--th-main">
                                    <i class="icon icon--apple"></i>
                                </a>-->
                                <a target="_blank" href="https://apps.rustore.ru/app/ru.sibgenco.general" class="app-links__button button-icon button-icon--th-main">
                                    <img src="/images/rustore-black.svg" style=" width: 20px; height: 20px;" alt="">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-slider__slide swiper-slide">
                <div class="main-banner">
                    <div class="main-banner__bg">
                        <div class="main-banner__img img" style="background-image: url(/images/main-slider/desctop/new-main-5.jpg);"></div>
                    </div>
                    <div class="main-banner__head card">
                        <div class="main-banner__head-inner">
                            <div class="main-banner__title h1">Уважаемые потребители!</div>
                            <div class="main-banner__caption h4">
                                <p>Мы рады сообщить Вам о запуске нового Единого Портала Потребителей в режиме beta-тестирования.</p>
                                <p>Постепенно мы запустим все сервисы, чтобы Вам было удобнее работать и получать от нас необходимую информацию.</p>
                            </div>
                        </div>
                        <div class="main-banner__bottom">
                            Если Вы хотите сообщить нам об ошибке –
                            напишите письмо на почту <a href="mailto:epp@sibgenco.ru">epp@sibgenco.ru</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-slider__dots dots js-main-dots"></div>
        <div class="main-slider__nav">
            <div class="slider-ctrl">
                <button class="button-icon button-icon--th-main js-main-prev">
                    <i class="icon icon--arrow-left"></i>
                </button>
                <button class="button-icon button-icon--th-main js-main-next">
                    <i class="icon icon--arrow-right"></i>
                </button>
            </div>
        </div>
    </div>

</template>

<script>

    export default {
        created: function () {
        },
        methods: {
        },
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Scripts/app/main-slider/components/MainSlider.vue